export const MICRO_APPS_ALPHA = 'micro-apps-alpha';
export const MICRO_APPS_BETA = 'micro-apps-beta';
export const MICRO_APPS_FF = 'micro-apps';
